import {Model} from 'react3l-common';
import {Field} from 'react3l-decorators';

export class AppUserSwitchAccountCode extends Model {
  @Field(String)
  public code?: string;

  @Field(String)
  public message?: string;

  @Field(String)
  public status?: string;

  @Field(String)
  public requestId?: string;

  @Field(String)
  public data?: string;
}